import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from '../../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.ApplyCorrection`]: 'Apply Correction per AS 1289.2.3.1',
      [`${prefix}.Preparation.GrainSize`]: 'Grain Size',

      [`${prefix}.Equipment.Balance`]: 'Balance',
      [`${prefix}.Equipment.Hotplate`]: 'Hotplate',
      [`${prefix}.Equipment.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.Equipment.DryingTemperature`]: 'Drying Temperature',

      [`${prefix}.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.DryingTray.ContainerMass`]: 'Tare Mass',
      [`${prefix}.DryingTray.WetSoilAndContainerMass`]: 'Tare and Material Wet Mass',
      [`${prefix}.DryingTray.WetSoilMass`]: 'Material Wet Mass',
      [`${prefix}.DryingTray.ConstantDrySoilAndContainerMass`]: 'Tare and Material Dry Mass',
      [`${prefix}.DryingTray.ConstantDrySoilMass`]: 'Material Dry Mass',

      [`${prefix}.DryingTray.DateTimePlacedInOvenLocal`]: `Date and Time on Hotplate`,

      [`${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: `Tare and Material Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DrySoilMass`]: `Material Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DateTimeRemovedFromOvenLocal`]: `Date and Time Off Hotplate`,
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: `Drying Time`,

      [`${prefix}.Results.UncorrectedMoisturePercent`]: 'Uncorrected Moisture Content',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.MoistureContentPercent`]: '%',
      [`${prefix}.Results.AmendedMoisturePercent`]: '%',
    })
  );

export default getLabelConfig;
